import React, { useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import Faq from "./Faq";
import Update from "./Update";
import "./Styles/faq.scss";
import MiniMonkey from "../../Assets/Images/white-monkey.svg"

function FaqAndUpdate() {
  const [activeTab, setActiveTab] = useState("faqTab");

  const handleTabSelect = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="faq-custom-container">
      <div className="faq-custom-content">
        <div className="faq-custom-header">
          <h1>Updates & FAQ</h1>
          <small className="text-muted">Features, fixes & improvements.</small>
        </div>

        <div className="faq-options">
          <Button variant="default" onClick={() => handleTabSelect("faqTab")} className={`${activeTab === `faqTab` ? `active` : ``}`}>
            FAQ
          </Button>
          <Button variant="default" onClick={() => handleTabSelect("updateTab")} className={`${activeTab === `updateTab` ? `active` : ``}`}>
            Update
          </Button>

        </div>
        <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
          <Tab eventKey="updateTab">
            <Update />
          </Tab>
          <Tab eventKey="faqTab">
            <Faq />
          </Tab>
        </Tabs>

        <div className="support-block">
          <div className="logo-monkey">
            <img src={MiniMonkey} />
          </div>
          <h3>Can’t find any answer?</h3>
          <div >Let our customer support team help you out!</div>
          <a className="btn btn-primary email-support" href="https://www.socialchimp.ai/contact">Email Us</a>
      
        </div>
      </div>

    </div>
  );
}

export default FaqAndUpdate;
